export { MediaQueryOwn } from './MediaQueryOwn'



// WEBPACK FOOTER //
// ./src/views/components/MediaQueryOwn/index.ts